import { useSyncExternalStore } from "react";

export type Toast = { id: number; kind: "ok" | "err" | "pending" | "info"; text: string; hash?: string };

let toasts: Toast[] = [];
let seq = 0;
const subs = new Set<() => void>();
const emit = () => subs.forEach((f) => f());

function remove(id: number) {
  toasts = toasts.filter((t) => t.id !== id);
  emit();
}

export const toast = {
  show(kind: Toast["kind"], text: string, hash?: string, ttl = 6_000): number {
    const id = ++seq;
    toasts = [...toasts, { id, kind, text, hash }].slice(-4);
    emit();
    if (kind !== "pending") setTimeout(() => remove(id), ttl);
    return id;
  },
  update(id: number, kind: Toast["kind"], text: string, hash?: string) {
    toasts = toasts.map((t) => (t.id === id ? { ...t, kind, text, hash: hash ?? t.hash } : t));
    emit();
    if (kind !== "pending") setTimeout(() => remove(id), 7_000);
  },
  dismiss: remove,
};

export function useToasts(): Toast[] {
  return useSyncExternalStore(
    (f) => {
      subs.add(f);
      return () => subs.delete(f);
    },
    () => toasts,
  );
}
